import ShortUniqueId from 'short-unique-id';

const shortUniqueId = new ShortUniqueId();

export const getShortUniqueId = (length: number = 10): string => {
  return shortUniqueId.randomUUID(length);
};
